import { Tag } from '@chakra-ui/react';
import { useFocusedBranchContext } from '@packages/core/branch/focused-branch-context';
import { useTranslate } from '@tolgee/react';
import usePrinterDevices from '../logic/use-printer-device';

interface PrinterLabelProps {
  printerId: string | undefined | null;
}

export default function PrinterLabel({ printerId }: PrinterLabelProps) {
  const branch = useFocusedBranchContext();
  const { data, loading } = usePrinterDevices(branch.branch?.id ?? '');
  const { t } = useTranslate();

  if (loading || !printerId) {
    return (
      <Tag.Root>
        <Tag.Label>{t('page-rule.not-assign-printer')}</Tag.Label>
      </Tag.Root>
    );
  }

  const printer = data?.printerDevices.find((p) => p.id === printerId);

  if (!printer) {
    return null;
  }

  return (
    <Tag.Root>
      <Tag.Label>
        {t('page-rule.printer.label', 'Printer: {printer}', {
          printer: printer.name,
        })}
      </Tag.Label>
    </Tag.Root>
  );
}
